module.exports = __webpack_public_path__ + "static/media/newManualsTile.a1118716.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg/newManualsTile.png
// module id = 1510
// module chunks = 0